import { Link } from 'react-router-dom'

export default function AuthFooter() {
  return (
    <div className="mt-8 text-center">
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-500">
        <Link to="/legal/terms-of-use" className="hover:text-primary-600 transition-colors">
          Terms of Use
        </Link>
        <span className="text-gray-300">•</span>
        <Link to="/legal/privacy-policy" className="hover:text-primary-600 transition-colors">
          Privacy Policy
        </Link>
        <span className="text-gray-300">•</span>
        <Link to="/legal/barter-agreement" className="hover:text-primary-600 transition-colors">
          Barter Agreement
        </Link>
        <span className="text-gray-300">•</span>
        <Link to="/legal/escrow-policy" className="hover:text-primary-600 transition-colors">
          Escrow Policy
        </Link>
        <span className="text-gray-300">•</span>
        <Link to="/legal/rating-reviews-policy" className="hover:text-primary-600 transition-colors">
          Reviews Policy
        </Link>
      </div>
      <p className="mt-4 text-xs text-gray-400">
        &copy; {new Date().getFullYear()} BarterSheet by NERD LLC. All rights reserved.
      </p>
    </div>
  )
}
